
















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { copyText } from '@/modules/shared/helpers/utils/utils'

@Component({
  components: { inheritAttrs: false }
})
export default class CopyableText extends Vue {
  @Prop() copyableText: number | string
  @Prop({ default: null }) showText: string
  @Prop({ default: '' }) emptyShowTextLabel: string
  @Prop({ default: null }) showTextClass: string
  private isTooltip: boolean = false
  private isClicked: boolean = false

  toClipboard() {
    copyText(this.copyableText)
  }

  showTooltip() {
    this.isTooltip = true
    this.isClicked = true
    this.toClipboard()
  }

  get tooltipText() {
    return (this.copyableText) ? `کپی شد` : `متنی کپی نشد`
  }
}
